var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i18n',{class:_vm.$style.continue,attrs:{"path":"continue_message","tag":"p"},scopedSlots:_vm._u([{key:"here",fn:function(){return [_c('router-link',{attrs:{"to":_vm.routeHere}},[_vm._v(" "+_vm._s(_vm.$t("here"))+" ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }